interface PeriodControlProps {
  value: string;
  periods: { id: string; label: string }[];
  onChange: (periodId: string) => void;
}

export function PeriodControl({ value, periods, onChange }: PeriodControlProps) {
  return (
    <label className="field-group compact-field">
      <span>Tariff period</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {periods.map((period) => <option key={period.id} value={period.id}>{period.label}</option>)}
      </select>
    </label>
  );
}
